export const environment = {
  production: false,
  apiEndpoint: 'https://api-staging.qivos.net/sso/v1'
};
